import template from './logout.html';
import controller from './logout.controller';

/**
 * logout Component
 * @class
 */
const logoutComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default logoutComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/logout/logout.component.js
 **/